export default import.meta.ROLLDOWN_FILE_URL_K2AVFJzWK24VEk3_cP_5AQ